export default __webpack_public_path__ + "static/media/AmazoneShoppingCart.6c17ecda.png";